import { render, staticRenderFns } from "./OurBeliefsBannerSection.vue?vue&type=template&id=4bf9f240"
import script from "./OurBeliefsBannerSection.vue?vue&type=script&lang=ts"
export * from "./OurBeliefsBannerSection.vue?vue&type=script&lang=ts"
import style0 from "./OurBeliefsBannerSection.vue?vue&type=style&index=0&id=4bf9f240&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports